import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Application } from '../models';

export const applicationsUpdateActions = createActionGroup({
  source: 'Einreichung - Applications update',
  events: {
    // Drafts persist only the raw survey model; metadata DTO assembly is deferred to final submit.
    'Update': props<{ application: Application; surveyData?: Record<string, unknown> }>(),
    'Update success': props<{ concurrency: Date; surveyData?: Record<string, unknown> }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Update failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
